/* eslint-disable no-param-reassign */
export default {
    SET_COPY_FISCAL_ADDRESS(state, val) {
        state.copyFiscalAddress = val;
    }
};
